define('home/views/HomepageCommentsModuleEmptyView',[
    'backbone-marionette',
    'home/templates/homepageCommentsModuleEmptyView',
    'core/switches',
], function (
    Marionette,
    homepageCommentsModuleEmptyView,
    switches
) {
    'use strict';

    var HomepageCommentsModuleEmptyView = Marionette.ItemView.extend({
        template: homepageCommentsModuleEmptyView,
        templateHelpers: {
            onboardingWithoutChannels: switches.isFeatureActive('onboarding_without_channels'),
        },
    });

    return HomepageCommentsModuleEmptyView;
});

